var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 45H5C3.9 45 3 44.1 3 43V5C3 3.9 3.9 3 5 3H42C43.1 3 44 3.9 44 5V43C44 44.1 43.1 45 42 45Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 3H6V13H44V3Z",
    fill: "#3A89F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 10C39.1046 10 40 9.10457 40 8C40 6.89543 39.1046 6 38 6C36.8954 6 36 6.89543 36 8C36 9.10457 36.8954 10 38 10Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 42C32 42 20 42 8 42C6.89543 42 6 41.1046 6 40V13H44V42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5699 32.0985C22.7097 31.9635 22.7312 31.9324 22.8495 32.1193C23.129 32.462 23.2796 31.7039 22.871 31.7662C22.7419 31.787 22.6129 31.7039 22.4946 31.6832C22.3118 31.652 22.1398 32.057 22.0108 31.8078C21.8065 31.3924 21.6022 31.652 21.6129 31.9532C21.6022 32.1608 21.1505 32.4516 21.6237 32.5762C21.8602 32.8047 22.4839 32.5451 22.3441 32.9085C21.7527 33.4485 23.3548 33.3862 22.6667 32.95C22.5484 32.8566 22.4946 32.8358 22.6452 32.7527C23.1613 32.2751 22.0215 32.4931 22.5699 32.0985Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1075 31.3924C20.3118 31.5066 20.6129 31.3613 20.7527 31.6001C21.2903 31.922 21.5054 31.3716 21.0215 31.1432C21.3441 30.624 21.086 29.5336 20.7742 30.6863C20.5699 30.8732 19.8925 31.1847 20.1075 31.3924Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2796 33.6458C24.8065 33.7289 25.5161 32.462 24.5806 32.7839C24.3118 33.4796 24.2903 32.9293 23.8602 33.0331C23.5161 33.2408 23.9462 33.7081 24.2796 33.6458Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0753 29.326C21.2796 29.1702 21.5699 29.5648 21.6774 29.2948C21.7312 29.0975 22.1935 28.4537 21.7849 28.4952C20.9892 29.7102 21.0968 27.8929 20.6667 28.5991C20.6667 28.8794 20.7849 29.2636 21.0753 29.326Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1828 30.6032C23.0645 30.3851 23.5484 30.1982 23.3548 29.9282C22.8602 29.4506 22.828 30.3955 22.871 30.7174C22.8387 31.2678 23.4624 30.9874 23.1828 30.6032Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5376 31.4963C24.4516 31.5274 24.4839 31.652 24.5054 31.7143C24.6344 31.9739 24.1398 31.9116 24.2043 32.2128C24.4731 32.9708 25.4839 31.1536 24.5376 31.4963Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9677 35.733C27.7204 35.6915 27.2473 35.9407 27.4194 36.2003C27.8065 36.5118 28.7097 36.003 27.9677 35.733Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3118 31.3197C22.5269 31.3301 22.6129 31.2263 22.5806 31.0601C22.871 29.7829 21.3978 31.2678 22.3118 31.3197Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2043 29.4506C20.6559 29.3363 20.3441 28.9002 20.0108 28.9937C19.5269 29.326 19.6452 29.9282 20.2043 29.4506Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9892 34.4558C25.2688 34.5284 25.6989 34.1131 25.3871 33.9365C25.0108 33.7496 24.5806 34.2273 24.9892 34.4558Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7419 35.2553C26.7312 33.8535 25.5484 36.273 26.7312 35.2865C26.7312 35.2761 26.7419 35.2657 26.7419 35.2553Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2151 34.8504C30.2473 34.4142 29.7527 34.4142 29.6559 34.7361C29.6452 35.1619 30.1075 35.3073 30.2151 34.8504Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5591 33.3239C21.7097 33.49 21.9892 33.5004 22.0215 33.2616C21.957 32.5243 21.129 33.0435 21.5591 33.3239Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8602 36.2315C26.871 35.9303 26.3118 35.7538 26.2581 36.1795C26.3333 36.4911 26.7419 36.6364 26.8602 36.2315Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7312 30.8524C23.9892 30.9459 24.1613 30.7797 24.172 30.4994C24.2796 29.949 23.2151 30.7071 23.7312 30.8524Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6774 36.3041C30.0538 36.408 30.5269 36.9376 30.8387 36.7611C31.129 36.543 31 36.2211 30.6774 36.3041Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2258 34.5284C28.3979 34.3519 28.4301 34.0819 28.0753 34.0715C27.2581 34.1961 27.957 34.6219 28.2258 34.5284Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1183 36.543C27.0538 36.6987 27.2581 36.9272 27.4624 36.8753C28.2688 36.5534 27.3226 36.3041 27.1183 36.543Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5161 36.6261C29.7097 36.6987 29.9892 36.4599 30 36.273C29.9785 35.6603 29.2151 36.4391 29.5161 36.6261Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2151 32.4828C23.2151 32.7424 23.8495 32.9397 23.8172 32.4724C23.828 32.0882 23.3011 32.2751 23.2151 32.4828Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8925 28.5368C23.7634 28.1941 23.4839 28.5056 23.4516 28.7444C23.4409 29.2221 23.9677 28.8587 23.8925 28.5368Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6237 36.8026C28.7742 36.8337 29 36.6157 28.9785 36.4807C28.6452 36.1484 27.9892 36.6053 28.6237 36.8026Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0538 34.2169C26.2688 34.2688 26.5161 33.895 26.2688 33.8015C25.7849 33.7185 25.5161 33.9988 26.0538 34.2169Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7957 29.5025C26.6129 29.1494 26.2258 29.814 26.4194 29.9905C26.6452 30.1775 26.9032 29.6894 26.7957 29.5025Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.957 35.6084C28.9677 35.8888 29.6882 35.6499 29.6129 35.3903C29.6129 35.1203 28.9247 35.4111 28.957 35.6084Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.172 34.2169C27.2688 33.8639 26.8172 33.9054 26.7634 34.165C26.7849 34.6634 27.0323 34.7361 27.172 34.2169Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7957 31.7455C24.4194 31.7662 23.8602 31.164 23.5806 31.4132C23.4086 31.6624 23.4409 31.7974 23.7957 31.7455Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.172 31.7662C29.1935 31.4755 28.6989 31.5586 28.6559 31.7455C28.6667 32.1297 29.1183 32.2024 29.172 31.7662Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5591 31.8597C26.3011 31.8493 26.0645 32.2958 26.4301 32.327C26.7957 32.327 26.9032 31.9324 26.5591 31.8597Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4086 28.0591C20.2151 28.0383 20.0323 28.4952 20.3011 28.5471C20.5806 28.5471 20.7204 28.0902 20.4086 28.0591Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7097 33.1681C27.871 33.0539 27.7419 32.8358 27.5806 32.867C26.9892 33.0331 27.3763 33.4173 27.7097 33.1681Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6129 32.0258C25.914 32.0051 26.1075 31.6209 25.7097 31.6624C25.4624 31.5897 25.3441 31.9739 25.6129 32.0258Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6989 29.5233C20.3441 29.6167 20.5269 30.0528 20.828 30.0113C21.172 29.9386 21 29.409 20.6989 29.5233Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9462 33.9781C28.9892 34.2896 29.4301 34.0612 29.3548 33.7912C29.2473 33.6042 28.9785 33.8327 28.9462 33.9781Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5806 27.3841C20.6559 27.0207 20.3011 26.8441 20.2688 27.1868C20.2688 27.3945 20.4839 27.571 20.5806 27.3841Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4731 30.6447C21.3441 30.7174 21.2581 30.894 21.4516 30.9147C21.8495 30.9044 21.7312 30.4994 21.4731 30.6447Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1398 29.5856C25.2473 29.5025 25.1613 29.3363 25.0323 29.3779C24.8065 29.4298 24.9355 29.7829 25.1398 29.5856Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3441 36.6676C29.2258 36.6364 29.0645 36.7507 29.172 36.8337C29.2903 36.9895 29.5806 36.7714 29.3441 36.6676Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.129 30.4786C19.0753 30.4682 19.043 30.4578 19 30.4474V31.6416C19.2151 31.517 19.4731 31.4132 19.5269 31.517C19.4409 31.6312 19.2366 31.8493 19 32.0155V36.9999H23.0108C22.8387 36.8337 22.7097 37.0103 22.5484 36.896C22.4409 36.8234 22.5484 36.6676 22.6667 36.7091C22.8925 36.7611 23.172 36.0965 23.043 35.8161C23.086 35.6188 23.3871 36.0861 23.3763 36.2107C22.9355 36.4184 22.9677 36.7714 23.2151 36.9999H25.0968C25.4409 36.6884 25.957 36.7195 25.9462 36.3041C25.7634 36.0549 26.3871 35.598 25.7849 35.7953C25.6022 36.1068 25.6452 36.408 25.1183 36.3353C24.914 36.3665 25.2151 36.0653 24.9247 36.003C24.8495 35.9822 24.7527 35.9095 24.6882 36.0134C24.5591 36.2315 25.172 36.4807 24.7742 36.6468C24.2796 36.6987 24.2796 36.2107 24.5161 35.9303C24.7204 35.7849 24.2688 35.4942 24.6237 35.4111C24.8065 35.3384 24.7742 35.6396 24.8495 35.7122C25.5161 36.3561 25.172 34.7154 25.8387 35.1723C26.1505 35.4526 26.6022 34.4973 25.172 34.84C24.9892 34.9334 24.2903 34.8504 24.5269 34.3415C24.6882 34.1442 24.5161 33.6146 24.2473 33.8015C24.0538 34.0819 24.1183 34.6323 23.6129 34.4661C23.5484 34.435 23.5484 34.3623 23.5806 34.3C23.9462 33.7808 23.4946 33.8119 23.1398 33.4173C22.6022 33.0123 22.7527 34.2688 22.3871 33.9988C22.1613 33.2512 21.7634 33.895 21.4946 33.4796C21.3333 33.2616 21.172 33.002 20.9677 32.815C20.6022 32.7112 21.0108 32.4101 20.7527 32.2958C20.4946 32.2335 20.9677 32.1297 20.8172 31.8493C20.3871 31.299 20.3978 32.192 20.1075 32.3478C19.6989 32.8358 19.7312 32.2543 19.914 31.9947C20.172 31.7247 19.6022 31.652 19.8495 31.3924C20.2688 30.6136 19.5914 31.2159 19.3011 31.0497C19.0645 30.9147 19.6129 30.759 19.7634 30.7486C19.8387 30.6655 19.8817 30.4786 19.8495 30.3644C19.7419 30.084 20.172 30.0321 19.9785 29.8244C19.7312 29.6271 19.4409 30.0113 19.1935 30.1048C18.8602 30.2605 19.2688 30.4267 19.129 30.4786ZM23.1505 34.7777C23.3656 34.7154 23.828 35.0061 23.9247 35.0788C23.8065 35.1307 23.5699 35.1307 23.4516 35.2761C23.2366 35.5669 22.9247 34.8192 23.1505 34.7777ZM23.1183 34.1442C23.172 34.2481 22.9462 34.3 22.8602 34.3C22.5699 34.2169 23.0108 34.03 23.1183 34.1442ZM21.2903 35.0892C21.1828 35.1723 20.9785 34.975 21.1398 34.9023C21.2796 34.8607 21.4946 34.9853 21.2903 35.0892ZM22.3548 35.4423C22.3763 35.5772 22.5376 35.6915 22.5054 35.8369C22.3333 36.1068 21.7204 35.1307 22.172 35.2865C22.2473 35.3176 22.3441 35.3176 22.3548 35.4423ZM21.5054 33.9988C21.7097 34.0092 22.4409 34.2481 22.0323 34.4558C21.7204 34.1754 21.3656 34.6115 21.043 34.5907C20.6989 34.2481 21.1075 34.0196 21.5054 33.9988ZM20.2796 36.003C20.086 36.1484 19.7742 35.9719 19.7957 35.7849C20.0645 35.7434 20.2796 35.8576 20.4516 35.6292C21.0968 35.4838 20.7312 36.0342 20.2796 36.003ZM19.5914 33.1785C19.7957 32.8877 20.4624 32.7112 20.4839 33.2408C20.5914 33.5835 20.1935 33.4485 19.957 33.3966C19.6882 33.4589 19.5161 33.6042 19.5914 33.1785Z",
    fill: "#A6D1FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44 13H42V42H44V13Z",
    fill: "#A6D1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 19H32V23H36V19Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 27H32V31H36V27Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 19H22V23H26V19Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19H12V23H16V19Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27H22V31H26V27Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27H12V31H16V27Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 37.0001V38C48 40.2 46.2 42 44 42H9C11.2 42 13 40.1998 13 37.9998V36.9998L48 37.0001Z",
    fill: "#3A89F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 27V38.1701C19 41.1404 17.3544 43.8661 14.726 45.2495L9.5 48L4.27403 45.2495C1.64562 43.8661 0 41.1404 0 38.1701L0 27H19Z",
    fill: "#001959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 33.4998L13.5326 32L7.66701 37.9993L5.46639 35.7506L4 37.2504L7.66701 41L15 33.4998Z",
    fill: "#FFD500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 27,
    width: 12,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarShield);
export default __webpack_public_path__ + "static/media/calendar_shield.1c3974531363ca1cd7c24f291ffb0d08.svg";
export { ForwardRef as ReactComponent };